import { observable } from "mobx";
import PartnerListItem from "./partnerListItem";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RspPartnerList {
  @observable
  total!: number;

  @observable
  @Type(() => PartnerListItem)
  partners!: PartnerListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    partners: { required: true },
  };
}
